import React from "react";
import { Database, Server, BarChart3, Workflow, Code2 } from "lucide-react";

const skillGroups = [
  {
    title: "Core Data Engineering",
    icon: <Database size={18} />,
    skills: [
      "ETL Pipelines",
      "Data Modeling (Star Schema)",
      "SQL Optimization",
      "Data Warehousing",
      "API Integration",
    ],
  },
  {
    title: "Programming & Tools",
    icon: <Code2 size={18} />,
    skills: [
      "Python",
      "Pandas",
      "Requests",
      "MySQL",
      "PostgreSQL",
      "Git",
    ],
  },
  {
    title: "Automation & Orchestration",
    icon: <Workflow size={18} />,
    skills: [
      "Apache Airflow",
      "Cron Scheduling",
      "Data Pipelines",
      "Workflow Monitoring",
    ],
  },
  {
    title: "Analytics & Visualization",
    icon: <BarChart3 size={18} />,
    skills: [
      "Metabase",
      "Data Analysis",
      "Reporting",
      "Dashboard Design",
    ],
  },
  {
    title: "Systems & Backend",
    icon: <Server size={18} />,
    skills: [
      "REST APIs",
      "OAuth2",
      "Docker",
      "Linux",
      "Java & Servlets",
    ],
  },
];

const Skills = () => {
  return (
    <section
      id="skills"
      className="py-16 px-6 bg-gray-50 dark:bg-gray-900"
    >
      <div className="max-w-6xl mx-auto">
        {/* Section Title */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-semibold text-gray-800 dark:text-gray-100">
            Skills & Technologies
          </h2>
          <p className="mt-3 text-gray-500 dark:text-gray-400 max-w-2xl mx-auto">
            Core tools and technologies I use to design, build, and maintain reliable data pipelines and analytics systems.
          </p>
        </div>

        {/* Skill Groups */}
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {skillGroups.map((group, index) => (
            <div
              key={index}
              className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-6 transition-transform duration-200 hover:-translate-y-1 hover:shadow-md"
            >
              {/* Group Header */}
              <div className="flex items-center gap-2 mb-4 text-gray-700 dark:text-gray-200">
                <span className="p-2 rounded-lg bg-gray-100 dark:bg-gray-700">
                  {group.icon}
                </span>
                <h3 className="font-medium text-base">{group.title}</h3>
              </div>

              {/* Skills Tags */}
              <div className="flex flex-wrap gap-2">
                {group.skills.map((skill, i) => (
                  <span
                    key={i}
                    className="px-3 py-1.5 text-sm rounded-full bg-gradient-to-r from-gray-100 to-gray-200 dark:from-gray-700 dark:to-gray-600 text-gray-700 dark:text-gray-200 border border-gray-200 dark:border-gray-600 transition-all duration-200 hover:from-gray-200 hover:to-gray-300 dark:hover:from-gray-600 dark:hover:to-gray-500"
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
